<template>
  <div class="ui blue labeled icon top left pointing dropdown button" ref="dd">
    <i class="wrench icon"></i>
    <span class="text">{{ $t("tools") }}</span>
    <div class="menu">
      <div class="header">
        <i class="tags icon"></i>
        {{ $t("templates") }}
      </div>
      <div class="item" v-for="(tpl, idx) in templates" :key="idx" @click="insert(tpl)">
        <i :class="tpl.icon + ' icon'"></i>
        {{ tpl.name }}
      </div>
      <div class="divider"></div>
      <div class="header">
        <i class="calendar icon"></i>
        {{ $t("display") }}
      </div>
      <div class="item" @click="format">
        <i class="code icon"></i>
        {{ $t("format") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HtmlTemplate",
  props: {
    templates: Array
  },
  data() {
    return {};
  },
  methods: {
    format() {
      this.$emit("format");
    },
    insert(template) {
      this.$emit("insert_template", template.template);
    }
  },
  mounted() {
    window.jQuery(this.$refs.dd).dropdown();
  },
  created() {}
};
</script>
